// İSG uzmanı portalı — karar kartının kimlik döşemesi (`docs/reviews/
// S32c-gate-desk-polish.md` §3, "initials, not a silhouette"). Genel bir siluet HER kişi için
// AYNI görünür — kartın en değerli 96 px'ini sıfır bilgiye harcar ve bir güvenlik ekranında
// "fotoğraf yok / doğrulanmamış" gibi OKUNABİLİR. Baş harfler kişiye göre DEĞİŞİR — bu bir
// değişim SİNYALİDİR (auto-clear kalktığından bir karar dakikalarca ekranda kalabilir; görevli
// kartın DEĞİŞTİĞİNİ fark etmek zorunda).
//
// **Asla verdict-renkli değil, asla status ring taşımaz** (§3.3) — bant zaten TEK karar
// sinyalidir; kimlik döşemesi ikinci bir renkli sinyal OLMAZ.
//
// **Gerçek fotoğraf, aynı yuvaya, relayout OLMADAN (§3.4).** Baş harf katmanı HER ZAMAN
// render edilir; fotoğraf gelince (backend'de HENÜZ yok — DTO'da `photoUrl` YOK) üstüne
// `absolute inset-0 object-cover` bir `<img>` biner. Yavaş/bozuk/404 bir fotoğraf sıfır
// layout-shift ve hata durumu OLMADAN baş harflere düşer — baş harfler PENDING durumun
// KENDİSİDİR, ayrı bir iskelet/spinner YOKTUR. Emsal: `apps/mobile-supplier/src/ui/Avatar.tsx`
// (okundu, İMPORT edilmedi — app sınırı).

import { cn } from '@isgportal/shared';
import { initials } from '../../lib/format';

export interface VerdictAvatarProps {
  /** `null`/boş → tile boş kalır (`bg-surface-muted`, glif YOK) — "?" bir kimlik iddiası
   *  taşırdı, bu yüzden basılmaz (§3.5). */
  name: string | null | undefined;
  className?: string;
}

export function VerdictAvatar({ name, className }: VerdictAvatarProps) {
  const glyph = initials(name);
  return (
    <div
      aria-hidden="true"
      className={cn(
        'relative h-24 w-24 shrink-0 overflow-hidden rounded-md border border-border bg-surface-muted',
        className,
      )}
    >
      <div className="flex h-full w-full items-center justify-center text-3xl font-semibold tracking-wide text-fg">
        {glyph}
      </div>
      {/* Fotoğraf katmanı buraya biner: <img alt="" aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover" />. Kırpma sözleşmesi 1:1
          object-cover, merkez ağırlıklı — yüz kadrajı YÜKLEYENİN sorunudur, RENDERER'ın değil
          (§3.4 kural 2). ASLA tıklanabilir değil, lightbox/modal AÇMAZ (§3.4 kural 6). */}
    </div>
  );
}
